import React from 'react';
import { useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import RateReviewOutlinedIcon from '@material-ui/icons/RateReviewOutlined';

import { makeStyles } from '@material-ui/core/styles';

import { Layout } from '../../layouts/private/Private';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Title from '../../components/Title/Title';
import { isAdministradorOuCentral, isCoordenadorOuApoioSecretarial, isDigitador } from '../../security/AuthorizedFunction';

export const useStyles = makeStyles(theme => ({
    area: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '70%',
        minHeight: '60vh',
        margin: '0 auto',
        gap: theme.spacing(3),
    },
    button: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: '40vh',
        maxHeight: theme.spacing(30),
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2),
        textTransform: 'none',
    },
    buttonContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    icon: {
        fontSize: 64,
    },
    buttonTitle: {
        marginTop: theme.spacing(2),
    },
    buttonDescription: {
        marginTop: theme.spacing(1),
        opacity: 0.85,
    },
}));

const opcoes = [
    {
        key: 'digitar',
        path: '/admin/digitacao/digitar',
        title: 'Digitar Marcações',
        description: 'Abre uma sessão de digitação consumindo a fila principal.',
        icon: CreateOutlinedIcon,
        authorized: () => isCoordenadorOuApoioSecretarial() || isDigitador() || isAdministradorOuCentral(),
    },
    {
        key: 'revisar',
        path: '/admin/digitacao/revisar',
        title: 'Revisar Marcações',
        description: 'Abre uma sessão de revisão consumindo a fila de revisão.',
        icon: RateReviewOutlinedIcon,
        authorized: () => isAdministradorOuCentral(),
    },
];

const Digitacao = () => {
    const classes = useStyles();
    const history = useHistory();

    const links = [{ path: null, name: 'Logística Reversa' }];

    return (
        <Layout>
            <Grid container>
                <Grid item xs={12}>
                    <Breadcrumbs links={links} active="Digitação" />
                </Grid>
            </Grid>

            <Title>Digitação de Marcações</Title>

            <Box className={classes.area}>
                {opcoes.map(opcao => (
                    opcao.authorized() && (
                        <Button
                            key={opcao.key}
                            className={classes.button}
                            classes={{ label: classes.buttonContent }}
                            variant="contained"
                            color="primary"
                            onClick={() => history.push(opcao.path)}
                        >
                            <opcao.icon className={classes.icon} />
                            <Typography variant="h6" className={classes.buttonTitle}>{opcao.title}</Typography>
                            <Typography variant="body2" className={classes.buttonDescription}>{opcao.description}</Typography>
                        </Button>
                    )
                ))}
            </Box>
        </Layout>
    );
}

export default Digitacao;
